import { InjectionToken } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
export var REPORTING_FILTER_OPTIONS = new InjectionToken('Reporting filter options.');
var ReportingFilterOptionsService = /** @class */ (function () {
    function ReportingFilterOptionsService(route) {
        var _this = this;
        this._cropsSubject = new ReplaySubject(1);
        this._flatTypesSubject = new ReplaySubject(1);
        this._potTypesSubject = new ReplaySubject(1);
        this._substratesSubject = new ReplaySubject(1);
        this._laboratoriesSubject = new ReplaySubject(1);
        this._growthStagesSubect = new ReplaySubject(1);
        route
            .data
            .subscribe(function (d) {
            var options = d.filterOptions;
            _this._cropsSubject.next(options.crops);
            _this._flatTypesSubject.next(options.flatContainers);
            _this._potTypesSubject.next(options.potContainers);
            _this._substratesSubject.next(options.substrates);
            _this._laboratoriesSubject.next(options.laboratories);
            _this._growthStagesSubect.next(options.growthStages);
        });
    }
    Object.defineProperty(ReportingFilterOptionsService.prototype, "crops", {
        get: function () {
            return this._cropsSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportingFilterOptionsService.prototype, "flatTypes", {
        get: function () {
            return this._flatTypesSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportingFilterOptionsService.prototype, "potTypes", {
        get: function () {
            return this._potTypesSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportingFilterOptionsService.prototype, "substrates", {
        get: function () {
            return this._substratesSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportingFilterOptionsService.prototype, "laboratories", {
        get: function () {
            return this._laboratoriesSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportingFilterOptionsService.prototype, "growthStages", {
        get: function () {
            return this._growthStagesSubect.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    return ReportingFilterOptionsService;
}());
export { ReportingFilterOptionsService };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/reporting/services/reporting-filter-options.service.ts.pre-build-optimizer.js